import React, { Component } from "react";

export class SearchResultChalet extends Component {
  state = {};
  render() {
    return (
      <div className="col-12 col-xl-4 col-lg-6 mb-4 ftco-animate fadeInUp ftco-animated">
        <a
          href={this.props.item.link}
          className="block-5"
          style={{ backgroundImage: `url(${this.props.item.image})` }}
        >
          <div className="text">
            <h3 className="heading">{this.props.item.name}</h3>
            <div className="post-meta">
              <span>
                {this.props.item.currencySymbol}
                {this.props.item.total.toLocaleString("en-GB", {
                  style: "decimal",
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                })}{" "}
                for total stay
              </span>
              <br />
              <span>{this.props.item.resort}</span>
            </div>
          </div>
        </a>
      </div>
    );
  }
}
